import { cn as l } from "../../../lib/utils.es.js";
import { jsx as r } from "react/jsx-runtime";
import * as t from "@radix-ui/react-avatar";
var o = ({ className: a, size: i = "default", ...e }) => /* @__PURE__ */ r(t.Root, {
  className: l("lib:group/avatar lib:relative lib:flex lib:size-8 lib:shrink-0 lib:select-none lib:overflow-hidden lib:rounded-full lib:data-[size=lg]:size-10 lib:data-[size=sm]:size-6", a),
  "data-size": i,
  "data-slot": "avatar",
  ...e
}), u = ({ className: a, ...i }) => /* @__PURE__ */ r(t.Image, {
  className: l("lib:aspect-square lib:size-full", a),
  "data-slot": "avatar-image",
  ...i
}), g = ({ className: a, ...i }) => /* @__PURE__ */ r(t.Fallback, {
  className: l("lib:flex lib:size-full lib:items-center lib:justify-center lib:rounded-full lib:bg-muted lib:text-muted-foreground lib:text-sm lib:group-data-[size=sm]/avatar:text-xs", a),
  "data-slot": "avatar-fallback",
  ...i
}), d = ({ className: a, ...i }) => /* @__PURE__ */ r("span", {
  className: l("lib:absolute lib:right-0 lib:bottom-0 lib:z-10 lib:inline-flex lib:select-none lib:items-center lib:justify-center lib:rounded-full lib:bg-primary lib:text-primary-foreground lib:ring-2 lib:ring-background", "lib:group-data-[size=sm]/avatar:size-2 lib:group-data-[size=sm]/avatar:[&>svg]:hidden", "lib:group-data-[size=default]/avatar:size-2.5 lib:group-data-[size=default]/avatar:[&>svg]:size-2", "lib:group-data-[size=lg]/avatar:size-3 lib:group-data-[size=lg]/avatar:[&>svg]:size-2", a),
  "data-slot": "avatar-badge",
  ...i
}), v = ({ className: a, ...i }) => /* @__PURE__ */ r("div", {
  className: l("lib:group/avatar-group lib:flex lib:-space-x-2 lib:*:data-[slot=avatar]:ring-2 lib:*:data-[slot=avatar]:ring-background", a),
  "data-slot": "avatar-group",
  ...i
}), n = ({ className: a, ...i }) => /* @__PURE__ */ r("div", {
  className: l("lib:relative lib:flex lib:size-8 lib:shrink-0 lib:items-center lib:justify-center lib:rounded-full lib:bg-muted lib:text-muted-foreground lib:text-sm lib:ring-2 lib:ring-background lib:group-has-data-[size=lg]/avatar-group:size-10 lib:group-has-data-[size=sm]/avatar-group:size-6 lib:[&>svg]:size-4 lib:group-has-data-[size=lg]/avatar-group:[&>svg]:size-5 lib:group-has-data-[size=sm]/avatar-group:[&>svg]:size-3", a),
  "data-slot": "avatar-group-count",
  ...i
});
export {
  o as Avatar,
  d as AvatarBadge,
  g as AvatarFallback,
  v as AvatarGroup,
  n as AvatarGroupCount,
  u as AvatarImage
};
